import { generateId } from "@msuite/utils/strings";
import { type PropsWithChildren, useState } from "react";
import type { ClassNameProps } from "../types";
import { cn } from "../utils";
import { ContainerProvider } from "./context";

/** Props Interface */
interface LightboxContainerProps extends PropsWithChildren, ClassNameProps {}

export function Container({ children, className }: LightboxContainerProps) {
	const [containerId] = useState(generateId());

	/** Render */
	return (
		<ContainerProvider containerId={containerId}>
			<div className={cn("h-stack flex-wrap", `lightbox-container-${containerId}`, className)}>
				{children}
			</div>
		</ContainerProvider>
	);
}
